import React from "react";
import Labeled from "../Labeled";
import classes from "./LabeledTextArea.module.css";

type LabeledTextAreaProps = {
    id: string;
    label: string;
    placeholder?: string;
    small?: string;
    value?: string;
    change?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
    isValid?: boolean;
};

const LabeledTextArea: React.FC<LabeledTextAreaProps> = (props) => {
    return (
        <Labeled id={props.id} label={props.label} small={props.small}>
            <textarea
                className={[
                    classes.LabeledTextArea,
                    props.isValid || props.isValid === undefined ? "" : classes.invalid
                ].join(" ")}
                id={props.id}
                placeholder={props.placeholder}
                spellCheck={false}
                rows={5}
                value={props.value}
                wrap="off"
                onChange={props.change}></textarea>
        </Labeled>
    );
};

export default LabeledTextArea;
